import React from 'react';
import {runInAction} from 'mobx';
import {observer} from 'mobx-react';
import s from '../s';

const CustomFieldsComponent: React.FC = observer(() => {
    const save1 = (e: React.ChangeEvent<HTMLInputElement>) => {
        runInAction(() => {
            s.ps.custom_text_1 = e.target.value.truncate(200, false);
        });
    };

    const save2 = (e: React.ChangeEvent<HTMLInputElement>) => {
        runInAction(() => {
            s.ps.custom_text_2 = e.target.value.truncate(200, false);
        });
    };

    const save3 = (e: React.ChangeEvent<HTMLInputElement>) => {
        runInAction(() => {
            s.ps.custom_text_3 = e.target.value.truncate(200, false);
        });
    };

    if (!s.ready || !s.ui.show_cust || s.prod.IsCAF) {
        return null;
    }

    return (
        <div className="gray-box">
            <div>
                <div>
                    <div>
                        {s.prod.CustomField1_Enabled && (
                            <div>
                                <label
                                    htmlFor="custom-field-1"
                                    className="b"
                                >
                                    {s.prod.CustomField1_Title}
                                </label>
                                <div>
                                    <input
                                        id="custom-field-1"
                                        type="text"
                                        className="form-control"
                                        style={{width: 250}}
                                        onChange={save1}
                                        maxLength={200}
                                        aria-label={`Enter ${s.prod.CustomField1_Title}`}
                                    />
                                </div>
                            </div>
                        )}
                        {s.prod.CustomField2_Enabled && (
                            <div className="mt-2">
                                <label
                                    htmlFor="custom-field-2"
                                    className="b"
                                >
                                    {s.prod.CustomField2_Title}
                                </label>
                                <input
                                    id="custom-field-2"
                                    type="text"
                                    className="form-control"
                                    style={{width: 250}}
                                    onChange={save2}
                                    maxLength={200}
                                    aria-label={`Enter ${s.prod.CustomField2_Title}`}
                                />
                            </div>
                        )}
                        {s.prod.CustomField3_Enabled && (
                            <div className="mt-2 mb-2">
                                <label
                                    htmlFor="custom-field-3"
                                    className="b"
                                >
                                    {s.prod.CustomField3_Title}
                                </label>
                                <input
                                    id="custom-field-3"
                                    type="text"
                                    className="form-control"
                                    style={{width: 250}}
                                    onChange={save3}
                                    maxLength={200}
                                    aria-label={`Enter ${s.prod.CustomField3_Title}`}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CustomFieldsComponent;
